import React, { useState, memo, useCallback } from "react";
import { useRecoilState } from "recoil";

import { unavailableState } from '../../../store/unavailableState';

import { NewUnacceptanceResult } from '../parts/NewUnacceptanceResult';
import { EditUnacceptanceResult } from '../parts/EditUnacceptanceResult';

export const UnavailableAcceptanceResult = (props) => {
  const { init_hospital, corporations } = props;
  const [unavailableData, setUnavailableData] = useRecoilState(unavailableState);

  const addUnavailable = useCallback((new_item) => {
    setUnavailableData([...unavailableData, new_item]);
  }, [unavailableData]);

  const removeUnavailable = useCallback((remove_item) => {
    setUnavailableData(unavailableData.filter(item => {
      return item.id !== remove_item;
    }));
  }, [unavailableData]);

  return (
    <>
      <NewUnacceptanceResult hospital_id={init_hospital.id} corporations={corporations} addAcceptanceResult={addUnavailable} type_val='Unavailable' />
      <div className="row">
        <table className="table table-striped table-hover mb-3">
          <tbody>
          {unavailableData.map(unavailable => 
              <EditUnacceptanceResult key={unavailable.id} init_acceptance_result={unavailable} removeAcceptanceResult={removeUnavailable} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};